import React from "react"
import { nanoid } from "nanoid"

import Ingredients from "./Ingredients"
import Equipment from "./Equipment"

function Steps({ steps }) {
    const ingredients = steps.map( item => item.ingredients )
    const equipment = steps.map( item => item.equipment )

    const handleClick = (e) => e.target.previousElementSibling.firstChild.checked = !e.target.previousElementSibling.firstChild.checked

    return (
        <>
            <h3>Ingredients</h3>
            <Ingredients ingredients={ingredients} />

            <h3>Equipment</h3>
            <Equipment equipment={equipment} />

            <section className="steps">
                <h3>Steps</h3>
                {
                    steps.map( item => {
                        return  <div key={nanoid()}>
                            <div>
                                <input type="checkbox" name="ingredient" aria-label="ingredient" />
                            </div>
                            <label htmlFor="ingredient" onClick={handleClick}>{item.step}</label>
                        </div>
                    })
                }
            </section>
        </>
    )
}

export default Steps
